import supabase from '@/services/supabaseClient';
export { resolvePhoneVerificationState, phoneSavePatch, normalizeVerificationPhone } from '../../../supabase/functions/_shared/phoneVerificationAuthority.mjs';
export async function verificationRequest(action, { phone, channel, role, code, languageCode } = {}) {
  const { data, error } = await supabase.functions.invoke(action === 'verify' ? 'verify-otp' : 'send-otp', {
    body: { phone, role, ...(action === 'capabilities' ? { action } : action === 'verify' ? { code } : { channel, app_language: languageCode }) },
  });
  if (error || data?.ok !== true) throw Object.assign(new Error(data?.error || error?.message || 'verification_unavailable'), { code: data?.error });
  return data;
}
export async function saveVerificationPhone({ phone, role, userId }) {
  const table = role === 'doctor' ? 'doctor_profiles' : 'patient_profiles';
  const { data: existing, error: readError } = await supabase.from(table).select('phone,phone_verified_at').eq('user_id', userId).maybeSingle();
  if (readError) throw readError;
  const { phoneSavePatch } = await import('../../../supabase/functions/_shared/phoneVerificationAuthority.mjs');
  const { error } = await supabase.from(table).upsert({ user_id: userId,
    ...phoneSavePatch({ phone, savedPhone: existing?.phone, verifiedAt: existing?.phone_verified_at }),
    updated_at: new Date().toISOString() }, { onConflict: 'user_id' });
  if (error) throw error;
}
